export default __webpack_public_path__ + "static/media/zoko-tag-round.d297fe9a.svg";